export enum RestrictionTypes {
  ALL = 'all',
  INVENTORY_ANY_LOCATION = 'inventory_any_location',
  INVENTORY_MY_LOCATION = 'inventory_my_location',
  UOM_MISMATCH = 'uom_mismatch',
}
